/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { UserViewModel } from "../models/user-view-model";
@Injectable({
  providedIn: "root",
})
class AdminUsersService extends __BaseService {
  static readonly adminUsersGetUsersPath = "/api/admin/user/AdminUsers";
  static readonly adminUsersPostUserPath = "/api/admin/user/AdminUsers";
  static readonly adminUsersGetUserPath = "/api/admin/user/AdminUsers/{id}";
  static readonly adminUsersPutUserPath = "/api/admin/user/AdminUsers/{id}";
  static readonly adminUsersDeleteUsersPath = "/api/admin/user/AdminUsers/{id}";
  static readonly adminUsersUpdateSubscriptionUserRolePath =
    "/api/admin/user/AdminUsers/UpdateSubscriptionUserRole";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  adminUsersGetUsersResponse(): __Observable<
    __StrictHttpResponse<Array<UserViewModel>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/user/AdminUsers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<UserViewModel>>;
      })
    );
  }
  adminUsersGetUsers(): __Observable<Array<UserViewModel>> {
    return this.adminUsersGetUsersResponse().pipe(
      __map((_r) => _r.body as Array<UserViewModel>)
    );
  }

  /**
   * @param users undefined
   */
  adminUsersPostUserResponse(
    users: UserViewModel
  ): __Observable<__StrictHttpResponse<UserViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = users;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/user/AdminUsers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserViewModel>;
      })
    );
  }
  /**
   * @param users undefined
   */
  adminUsersPostUser(users: UserViewModel): __Observable<UserViewModel> {
    return this.adminUsersPostUserResponse(users).pipe(
      __map((_r) => _r.body as UserViewModel)
    );
  }

  /**
   * @param id undefined
   */
  adminUsersGetUserResponse(
    id: number
  ): __Observable<__StrictHttpResponse<UserViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/user/AdminUsers/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserViewModel>;
      })
    );
  }
  /**
   * @param id undefined
   */
  adminUsersGetUser(id: number): __Observable<UserViewModel> {
    return this.adminUsersGetUserResponse(id).pipe(
      __map((_r) => _r.body as UserViewModel)
    );
  }

  /**
   * @param params The `AdminUsersService.AdminUsersPutUserParams` containing the following parameters:
   *
   * - `users`:
   *
   * - `id`:
   */
  adminUsersPutUserResponse(
    params: AdminUsersService.AdminUsersPutUserParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.users;

    let req = new HttpRequest<any>(
      "PUT",
      this.rootUrl + `/api/admin/user/AdminUsers/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminUsersService.AdminUsersPutUserParams` containing the following parameters:
   *
   * - `users`:
   *
   * - `id`:
   */
  adminUsersPutUser(
    params: AdminUsersService.AdminUsersPutUserParams
  ): __Observable<Blob> {
    return this.adminUsersPutUserResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  adminUsersDeleteUsersResponse(
    id: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/api/admin/user/AdminUsers/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param id undefined
   */
  adminUsersDeleteUsers(id: number): __Observable<boolean> {
    return this.adminUsersDeleteUsersResponse(id).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param params The `AdminUsersService.AdminUsersUpdateSubscriptionUserRoleParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `subscriptionId`:
   *
   * - `newRole`:
   *
   * - `isUserMamanger`:
   *
   * - `isInvoiceManager`:
   */
  adminUsersUpdateSubscriptionUserRoleResponse(
    params: AdminUsersService.AdminUsersUpdateSubscriptionUserRoleParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.subscriptionId != null)
      __params = __params.set(
        "subscriptionId",
        params.subscriptionId.toString()
      );
    if (params.newRole != null)
      __params = __params.set("newRole", params.newRole.toString());
    if (params.isUserMamanger != null)
      __params = __params.set(
        "isUserMamanger",
        params.isUserMamanger.toString()
      );
    if (params.isInvoiceManager != null)
      __params = __params.set(
        "isInvoiceManager",
        params.isInvoiceManager.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/user/AdminUsers/UpdateSubscriptionUserRole`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `AdminUsersService.AdminUsersUpdateSubscriptionUserRoleParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `subscriptionId`:
   *
   * - `newRole`:
   *
   * - `isUserMamanger`:
   *
   * - `isInvoiceManager`:
   */
  adminUsersUpdateSubscriptionUserRole(
    params: AdminUsersService.AdminUsersUpdateSubscriptionUserRoleParams
  ): __Observable<boolean> {
    return this.adminUsersUpdateSubscriptionUserRoleResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }
}

module AdminUsersService {
  /**
   * Parameters for AdminUsersPutUser
   */
  export interface AdminUsersPutUserParams {
    users: UserViewModel;
    id: number;
  }

  /**
   * Parameters for AdminUsersUpdateSubscriptionUserRole
   */
  export interface AdminUsersUpdateSubscriptionUserRoleParams {
    userId?: number;
    subscriptionId?: number;
    newRole?: 0 | 1 | 2 | 3 | 4;
    isUserMamanger?: boolean;
    isInvoiceManager?: boolean;
  }
}

export { AdminUsersService };
